module.exports = __webpack_public_path__ + "media/images/top/idea-item03-16e9034079a5a6702140dc73c2c3a064.webp";